<template>
  <nuxt-img
    :src="imageUrl"
    :alt="alt"
    :style="{ 'min-height': minHeight }"
    :width="width"
    :height="height"
  />
</template>

<script setup lang="ts">
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  minHeight: {
    type: String,
    required: true,
  },
  localize: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
  },
  height: {
    type: Number,
  },
});

const { locale } = useI18n();

const imageUrl = computed(() => {
  if (!props.localize) {
    return props.src;
  }

  switch (locale.value) {
    case 'es':
      return `/images/es/ES_${props.src}`;
    case 'es-mx':
      return `/images/mx/MX_${props.src}`;
    case 'de':
      return `/images/de/DE_${props.src}`;
    case 'pt':
      return `/images/pt/PT_${props.src}`;
    case 'pt-br':
      return `/images/br/BR_${props.src}`;
    case 'fr':
      return `/images/fr/FR_${props.src}`;
    case 'it':
      return `/images/it/IT_${props.src}`;
    case 'en':
    default:
      return `/images/en/EN_${props.src}`;
  }
});
</script>
